// extracted by mini-css-extract-plugin
export default {"themedComponent":"themedComponent_mlkZ","themedComponent--light":"themedComponent--light_NVdE","themedComponent--dark":"themedComponent--dark_xIcU"};